/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

import { useEffect, useState } from 'react';
import { getReVariant, onReVariantChange } from './variant';

/** The tenant's Real Estate variant pack; re-renders when it arrives. */
export default function useReVariant() {
  const [pack, setPack] = useState(getReVariant);
  useEffect(() => {
    setPack(getReVariant());
    return onReVariantChange(setPack);
  }, []);
  return pack;
}
